<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.deviceId" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.deviceId" :key="item.deviceId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="点位编码"  v-if="type==0">
					<el-select v-model="filters.deviceId" filterable>
						<!-- <el-option  label="全选" value="" > </el-option> -->
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.deviceId" :key="item.deviceId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="运维公司" >
					<el-select v-model="filters.operationcompanyId"  filterable  placeholder="请选择运维公司">
						<el-option
							v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow  ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="dataDayList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight"   size="small" >
			<el-table-column type="index" label="序号"  ></el-table-column>
            <el-table-column prop="remainingTime" label="剩余时间（天）"    ></el-table-column>
            <el-table-column prop="projectName" label="项目名称"    ></el-table-column>
			<el-table-column prop="siteName" label="点位名称"    ></el-table-column>
            <el-table-column prop="operationcompanyName" label="运维公司"    ></el-table-column>
            <el-table-column prop="operationcompanyCycle" label="运维周期（天）"    ></el-table-column>
            <el-table-column prop="time" label="运维日期"    ></el-table-column>
            <el-table-column prop="operationcompanyPhone" label="运维电话"    ></el-table-column>
            <el-table-column   label="运维记录"  >
                <template slot-scope="scope">
					<table-query-button   @select-type="getMaintenanceRecord(scope.$index, scope.row)" ></table-query-button>
				</template>
            </el-table-column>
		</el-table>

        <el-dialog title="运维记录" :visible.sync="dialogRecordVisible"  :append-to-body="true"  width="80%">
			<el-table :data="maintenanceRecordList" border highlight-current-row  size="mini">
				<el-table-column type="index" label="序号" ></el-table-column >
				<el-table-column  prop="time" label="运维时间"   ></el-table-column>
				<el-table-column  prop="voicebefore" label="校准前"   ></el-table-column>
				<el-table-column  prop="voicecorrect" label="修正值">
					<template slot-scope="scope">
						<span v-if="scope.row.voicecorrect<=0.5&&scope.row.voicecorrect>=-0.5" style="color:green">{{scope.row.voicecorrect}}</span>
						<span v-else style="color:red">{{scope.row.voicecorrect}}</span>
					</template>
				</el-table-column>
				<el-table-column  prop="voiceafter" label="校准后" ></el-table-column>
                <el-table-column  prop="voicestandard" label="标准值" ></el-table-column>
				<el-table-column  label="现场图片" >
					<template slot-scope="scope">
						<span v-if="scope.row.picture==''||scope.row.picture==null" >  </span>
						<span v-else >
							<el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.srcList">  </el-image>
						</span>
					</template>
				</el-table-column>
                 <el-table-column  prop="remark" label="描述信息" ></el-table-column>
			</el-table>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,getOperationCompanyList,getMaintenanceStatus,getMaintenanceRecord} from '../../api/api';

	import myButton from '../../components/myButton/index.vue'
	import TableQueryButton from '../../components/myButton/TableQueryButton.vue'

	export default {
	components: { myButton ,TableQueryButton},
		data() {
			return {
				filters: {
					projectId:"",
					deviceId:"",
					operationcompanyId:""
				},
				listLoading: false,
				firstFlag:true,
				devices:[],
				projects:[],
				formHeight:0,

				type:sessionStorage.getItem("type"),

				dataDayList:[],

				userId:sessionStorage.getItem('userId'),

                operationcompanyList:[],
                maintenanceRecordList:[],

                dialogRecordVisible:false,

				projectIdNow:0
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getMaintenanceStatus();
				}else if(type=="reset"){
					this.reset();
				}
			},
            getOperationCompanyList(){
                if(this.operationcompanyList.length>0){
                    return;
                }
				getOperationCompanyList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.operationcompanyList = res.data.data;
				});
            },
			getMaintenanceStatus(){
                let para=this.filters;
                para.userId=this.userId;
                getMaintenanceStatus(para).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.dataDayList = res.data.data; 
					this.projectIdNow=this.filters.projectId;
				});
			},
            getMaintenanceRecord(i,row){
                this.dialogRecordVisible=true;
                let para={
                    deviceId:row.deviceId,
					projectId:this.projectIdNow
                };
				para.page= 1;
                para.pageSize=500;
				para.startDate='';
                para.endDate='';
                getMaintenanceRecord(para).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.maintenanceRecordList = res.data.data;
					this.maintenanceRecordList.forEach(element => {
                        var arr=[];
						if(element.picture!=""&&element.picture!=null){
							console.log(element.picture)
							var imgarr=element.picture.split(';');
							for(var j=0;j<imgarr.length;j++){
								if(imgarr[j]==""){
									continue;
								}
								var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
								arr.push(url);
							}
							element.srcList=arr;
						}
					});
				});
			},
			reset(){
				this.filters.deviceId="";
				this.filters.operationcompanyId="";
				this.getMaintenanceStatus();
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
						this.getMaintenanceStatus();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					this.filters.deviceId="";
				});
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				this.formHeight=hgt-titleHgt-150;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.getProjects();
            this.getOperationCompanyList();
		}, 
	}

</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// MaintenanceStatus.vue?de94854c